import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3df85777&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3df85777&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df85777",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3df85777')) {
      api.createRecord('3df85777', component.options)
    } else {
      api.reload('3df85777', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3df85777&scoped=true", function () {
      api.rerender('3df85777', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GuoJiao/requirementAnalysis/index.vue"
export default component.exports